import { CashflowTransactionEntry } from './types';

export const getMerchantName = (transactionEntry: CashflowTransactionEntry) =>
    transactionEntry.merchant?.name || transactionEntry.name;
